import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import type { ModelComparisonRow } from '../../../api/agent-miner-client/agent-miner-client.type';
import { Table } from '../../../components/table/table';
import { getUsageColumns } from './usage-table.columns';

type Props = {
  rows: ModelComparisonRow[];
};

/**
 * The token-usage breakdown table: one row per model family with input,
 * output, cache-read, cache-creation, and total token counts, sorted by total
 * tokens descending by default.
 *
 * @param {Props} props - Component props
 * @returns {JSX.Element} The rendered table
 */
export const UsageTable = ({ rows }: Props) => {
  const { t } = useTranslation();
  const columns = useMemo(() => getUsageColumns(t), [t]);

  return (
    <Table<ModelComparisonRow>
      data={rows}
      columns={columns}
      getRowId={(row) => row.model_family}
      defaultSortedBy="total_tokens"
      defaultSortedByDirection="desc"
      totalItems={rows.length}
      stickyHeader
    />
  );
};
